import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../Styles/topnav.css";

/**
 * Shared top nav bar for the assessment admin pages.
 *
 * Usage:
 *   <AssessmentTopNav />                    -> title defaults to "ASSESSMENT"
 *   <AssessmentTopNav title="CLIENTS" />    -> for the Companies page
 */
export default function AssessmentTopNav({ title = "ASSESSMENT" }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("assessmentAdminToken");
    localStorage.removeItem("assessmentAdminName");
    localStorage.removeItem("assessmentAdminEmail");
    localStorage.removeItem("assessmentAdminRole");
    navigate("/admin/assessment/login");
  };

  return (
    <header className="as-assessment-topnav">
      <h1 className="as-assessment-topnav-title">{title}</h1>

      <button
        type="button"
        className="as-assessment-topnav-logout"
        onClick={handleLogout}
      >
        <svg
          className="as-assessment-topnav-logout-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 17l5-5-5-5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 12H3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Logout
      </button>
    </header>
  );
}
